import { Suspense, type PropsWithChildren } from 'react'

import { ListaQuadrasEspelhoDeVendasHorizontalSkeleton } from '@/features/espelho-de-vendas/shared/components/espelho-de-vendas-horizonta.skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'

export const EspelhoDeVendasHorizontalPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ListaQuadrasEspelhoDeVendasHorizontalSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
